
export const mailToUs = () => {
    window.location.href = "mailto:hello@p22.studio";
}